export default __webpack_public_path__ + "static/media/twitter.48adb6ce.svg";